import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-outlet',
  templateUrl: './profile-outlet.component.html',
  styleUrls: ['./profile-outlet.component.scss']
})
export class ProfileOutletComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
